import { Typography } from '@mui/material'
import { Box, styled } from '@mui/system'
import PropTypes from 'prop-types'
import React  from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import PositionSliderBtn from './PositionSliderBtn'
import { TabItem } from '../../../../AppTabs'
import { useDefaultComponentTools } from '../../../../../hooks/useDefaultComponentTools'

export const SliderWrapper = styled(Box)(({ theme}) => ({
	maxWidth: '500px',
	position: 'relative',
	[theme.breakpoints.down('lg')]: {
		maxWidth: '350px'
	}
}))

const PositionSlider = ({tabs, handleTab, activeIndex}) => {
	const { t } = useDefaultComponentTools()
	const handleSlide = (index) => {
		handleTab(tabs[index].id, index)
	}
	const BREAKPOINTS = {
		0: { slidesPerView: 2 },
		992: { slidesPerView: 3 }
	}
	return (
		<SliderWrapper >
			<Swiper
				breakpoints={BREAKPOINTS}
				initialSlide={activeIndex}
			>
				<PositionSliderBtn handleSlide={handleSlide} title={'<'} customSx={{left:'-4px'}}/>
				{tabs.map((item, index) => {
					return <SwiperSlide key={index} >
						<TabItem onClick={() => handleTab(item.id, index)}
							active={activeIndex === index ? 1 : 0}
						>
							<Typography>
								{t(item.label)}
							</Typography>
						</TabItem>
					</SwiperSlide>
				})
				}
				<PositionSliderBtn handleSlide={handleSlide} title={'>'} customSx={{right:'-4px'}}/>
			</Swiper>
		</SliderWrapper>
	)
}

PositionSlider.propTypes = {
	active: PropTypes.string,
	activeIndex: PropTypes.number,
	handleTab: PropTypes.func,
	tabs: PropTypes.array
}

export default PositionSlider


